export const NONE_PROFILE_FORMAT = 'None';